module.exports = __webpack_public_path__ + "img/20200613_094625.62cea59d.jpg";